import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import * as general from '../../constants/General'

function OpenOrder(props) {
  const [time, setTime] = useState(0);
  let timepressure = 120;
  let timeparam = parseInt(props.param.SecondsTimePressure, 10);
  if (timeparam !== 0 && !isNaN(timeparam)) {
    timepressure = timeparam;
  }
  useEffect(() => {
    setTime(Math.round((new Date().getTime() - new Date(props.registrationDateTime).getTime()) / 1000));
    const timer = setInterval(() => {
      setTime((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [props.receiptline.ReceiptLineDetailId]);

  function updateOrderStatus(receiptLineDetailId) {
    console.log("UPDATE ORDER STATUS " + receiptLineDetailId);
    let orderStatus = 1;
    if(props.showOpen === false){
      orderStatus = 0
    }
    fetch(`${general.API_URL_UPDATE_ORDER}${receiptLineDetailId}/${orderStatus}`, {
      method: 'POST'
    }).then(() => {
      props.updateCall(receiptLineDetailId);
    });
  }
  if (props.showOpen) {
    return (
      <tr key={props.receiptline.ReceiptLineDetailId} onDoubleClick={() => updateOrderStatus(props.receiptline.ReceiptLineDetailId)}>
        {(props.param.HidePricelist ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "pricelist"}>
          {props.receiptline.PriceList.map(c => {
            return <p key={props.receiptline.ReceiptLineDetailId + c} style={{ margin: "0px 0px" }}>{c}</p>
          })}
        </td>)}
        {(props.param.HideObject ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "objectitem"}> {props.openorder.ObjectItem.ItemNumber === 0 ? "" : props.openorder.ObjectItem.ItemNumber}</td>)}
        {(props.param.HideTicket ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "receiptnumber"}>#{props.openorder.ReceiptNumber}</td>)}
        {(props.param.HideCustomer ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "customer"}>{props.openorder.Customer.Name}</td>)}
        {(props.param.HideUser ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "systemuser"}>{props.openorder.SystemUser.UserName}</td>)}
        {(props.param.HideTime ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "time"} style={{ backgroundColor: time >= timepressure ? "rgba(255, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.0)", color: time >= timepressure ? "white" : "black" }}>{Math.floor(time / 60)}:{(time % 60).toString().padStart(2, "0")}</td>)}
        <td key={props.receiptline.ReceiptLineDetailId + "quantity"} style={{ backgroundColor: props.showOpen === false ? "rgba(0, 255, 0, 0.6)" : "rgba(255, 255, 255, 0.0)" }}>{props.receiptline.Quantity}</td>
        <td key={props.receiptline.ReceiptLineDetailId + "articledescription"} style={{ backgroundColor: props.showOpen === false ? "rgba(0, 255, 0, 0.6)" : "rgba(255, 255, 255, 0.0)" }}>{props.receiptline.Article.Description}</td>
        {(props.param.HideConfigurations ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "configurations"}>
          {props.receiptline.Configurations.map(c => {
            return <p key={props.receiptline.ReceiptLineDetailId + c} style={{ margin: "0px 0px" }}>{c}</p>
          })}
        </td>
        )}
      </tr>
    )
  } else {
    return (
      <tr key={props.receiptline.ReceiptLineDetailId} onDoubleClick={() => updateOrderStatus(props.receiptline.ReceiptLineDetailId)}>
        {(props.param.HidePricelist ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "pricelist"}>
          {props.receiptline.PriceList.map(c => {
            return <p key={props.receiptline.ReceiptLineDetailId + c} style={{ margin: "0px 0px" }}>{c}</p>
          })}
        </td>)}
        {(props.param.HideObject ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "objectitem"}> {props.openorder.ObjectItem.Description}</td>)}
        {(props.param.HideTicket ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "receiptnumber"}>#{props.openorder.ReceiptNumber}</td>)}
        {(props.param.HideCustomer ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "customer"}>{props.openorder.Customer.Name}</td>)}
        {(props.param.HideUser ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "systemuser"}>{props.openorder.SystemUser.UserName}</td>)}
        {(props.param.HideTime ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "time"}>{props.openorder.ReceiptDateTime.split("T")[1].split(".")[0]}</td>)}
        <td key={props.receiptline.ReceiptLineDetailId + "quantity"} style={{ backgroundColor: props.showOpen === false ? "rgba(0, 255, 0, 0.6)" : "rgba(255, 255, 255, 0.0)" }}>{props.receiptline.Quantity}</td>
        <td key={props.receiptline.ReceiptLineDetailId + "articledescription"} style={{ backgroundColor: props.showOpen === false ? "rgba(0, 255, 0, 0.6)" : "rgba(255, 255, 255, 0.0)" }}>{props.receiptline.Article.Description}</td>
        {(props.param.HideConfigurations ? (null) : <td key={props.receiptline.ReceiptLineDetailId + "configurations"}>
          {props.receiptline.Configurations.map(c => {
            return <p key={props.receiptline.ReceiptLineDetailId + c} style={{ margin: "0px 0px" }}>{c}</p>
          })}
        </td>
        )}
      </tr>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {})(OpenOrder)



// WEBPACK FOOTER //
// src/freeformat/components/OpenOrder.jsx